import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import _ from 'lodash'
import { Button } from '@chakra-ui/react'
import { useSelector, useDispatch } from 'react-redux'
import SpinnerLoading from '../../../../components/Loading/SpinnerLoading'
import { useTranslation } from 'react-i18next'
import BackButton from 'components/Button/BackButton'
import { useParams, useHistory, Link } from 'react-router-dom'
import EngineeringIcon from '@mui/icons-material/Engineering'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import BadgeIcon from '@mui/icons-material/Badge'
import Groups2Icon from '@mui/icons-material/Groups2'
import * as actions from '../../../../redux/actions'

export default function ManagementPriority() {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)
  const params = useParams()
  const allStations = useSelector((state) => state.station)
  const [currentStation, setCurrentStation] = useState()
  const dispatch = useDispatch()
  const history = useHistory()

  useEffect(() => {
    dispatch(actions.stationAll()).then(() => {})
    return () => {}
  }, [params])

  useEffect(() => {
    if (allStations) {
      const tempcurrentStatus = _.find(
        allStations.arr,
        (station) => station._id === params.id
      )
      setCurrentStation(tempcurrentStatus)
      setIsLoading(true)
      console.log('Curent Station', currentStation)
    }
    return () => {}
  }, [params, allStations])

  if (currentStation && isLoading) {
    return (
      <div>
        <div className="relative  min-w-0 break-words bg-gray-100 w-full mb-6 shadow-lg rounded">
          <div className=" rounded-t mb-0 px-4 py-3 bg-transparent">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex-grow flex-1">
                <h6 className="uppercase text-gray-500 mb-1 text-xs font-semibold font-sans">
                  {t('setting.systemManagement')}
                </h6>
                <h2 className="text-gray-800 text-2xl font-bold font-sans">
                  จัดการสิทธิ์การเข้าถึงใน {currentStation.name}
                </h2>
              </div>
            </div>
            <Button>
              <BackButton />
            </Button>
          </div>
          <div className="grid sm:grid-cols-1 lg:grid-cols-4 ">
            <div className="grid px-5 py-4">
              <Link
                to={
                  '/system/stations/priority/config/' + 'USER' + '/' + params.id
                }
              >
                <div className=" bg-white shadow rounded py-10 px-16 transition-transform transform text-center hover:scale-105">
                  <i className=" text-gray-800 text-center text-lg">
                    <BadgeIcon fontSize="large" />
                  </i>
                  <p className=" text-gray-800 mb-0 text-center font-bold ">
                    พนักงานทั่วไป
                  </p>
                </div>
              </Link>
            </div>
            <div className="grid px-5 py-4">
              <Link
                to={
                  '/system/stations/priority/config/' +
                  'ADMIN' +
                  '/' +
                  params.id
                }
              >
                <div className=" bg-white shadow rounded py-10 px-16 transition-transform transform text-center hover:scale-105">
                  <i className=" text-gray-800 text-center text-lg">
                    <EngineeringIcon fontSize="large" />
                  </i>
                  <p className=" text-gray-800 mb-0 text-center font-bold ">
                    พนักงานระดับหัวหน้า
                  </p>
                </div>
              </Link>
            </div>
            <div className="grid px-5 py-4">
              <Link
                to={
                  '/system/stations/priority/config/' +
                  'MANAGER' +
                  '/' +
                  params.id
                }
              >
                <div className=" bg-white shadow rounded py-10 px-16 transition-transform transform text-center hover:scale-105">
                  <i className=" text-gray-800 text-center text-lg">
                    <Groups2Icon fontSize="large" />
                  </i>
                  <p className=" text-gray-800 mb-0 text-center font-bold ">
                    ผู้บริหาร
                  </p>
                </div>
              </Link>
            </div>
            <div className="grid px-5 py-4">
              <Link
                to={
                  '/system/stations/priority/config/' +
                  'SUPERUSER' +
                  '/' +
                  params.id
                }
              >
                <div className=" bg-white shadow rounded py-10 px-16 transition-transform transform text-center hover:scale-105">
                  <i className=" text-gray-800 text-center text-lg">
                    <ManageAccountsIcon fontSize="large" />
                  </i>
                  <p className=" text-gray-800 mb-0 text-center font-bold ">
                    ผู้ดูแลระบบ
                  </p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return <SpinnerLoading />
  }
}
